import { render, staticRenderFns } from "./ParamTable.vue?vue&type=template&id=6a35437f&scoped=true&"
import script from "./ParamTable.vue?vue&type=script&lang=js&"
export * from "./ParamTable.vue?vue&type=script&lang=js&"
import style0 from "./ParamTable.vue?vue&type=style&index=0&id=6a35437f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a35437f",
  null
  
)

export default component.exports